"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _typeof2 = _interopRequireDefault(require("/www/wwwroot/check/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.number.constructor");
var _request = _interopRequireDefault(require("@/utils/request"));
var _default = exports.default = {
  name: 'RiskReport',
  data: function data() {
    return {
      pay_risk_behavior_itf: {},
      // 探针c
      probeLoaded: false,
      probeEmpty: false,
      probeEmptyMsg: '',
      probeSeqNo: '',
      probeHit: false,
      unify: {},
      //全景雷达
      score_pano: {},
      //全景档案
      CourtDetailPro: {},
      //法院信息8类
      CourtListByType: {},
      //按照dataType发类后的可用数据
      courtLoaded: false,
      //法院详情是否已加载（含未查得）
      courtEmpty: false,
      //数据库未查得 / 无明细
      courtEmptyMsg: '',
      applyLoanC: {},
      // 3C 租赁 ApplyLoanC 嵌套结构
      applyLoanLoaded: false,
      applyLoanEmpty: false,
      applyLoanEmptyMsg: '',
      applyLoanSeqNo: '',
      blackInfo: {},
      blackLoaded: false,
      blackEmpty: false,
      blackEmptyMsg: '',
      blackSeqNo: '',
      blackHit: false,
      fengkongName: 'tab1',
      currentId: '',
      currentType: "",
      deviceType: 'desktop' // 设备类型: mobile, tablet, desktop
    };
  },
  computed: {
    applyLoanData: function applyLoanData() {
      var _this = this;
      var applyLoanC = this.applyLoanC || {};
      var timeDimensions = ['d3', 'd7', 'd14', 'm1', 'm3', 'm6', 'm12'];
      var fields = ['allnum', 'orgnum', 'weekend_allnum', 'weekend_orgnum', 'night_allnum', 'night_orgnum', 'tot_mons', 'avg_monnum', 'max_monnum', 'min_monnum'];
      var result = [];
      timeDimensions.forEach(function (time) {
        if (!applyLoanC[time]) return;
        var timeData = {
          time: _this.getTimeLabel(time)
        };
        fields.forEach(function (field) {
          var idValue = applyLoanC[time].id && applyLoanC[time].id[field] ? applyLoanC[time].id[field] : '0';
          var cellValue = applyLoanC[time].cell && applyLoanC[time].cell[field] ? applyLoanC[time].cell[field] : '0';
          timeData[field] = "".concat(idValue, "/").concat(cellValue);
        });
        result.push(timeData);
      });
      return result;
    },
    applyLoanTableFields: function applyLoanTableFields() {
      return [{
        key: 'allnum',
        label: '申请总次数'
      }, {
        key: 'orgnum',
        label: '申请总机构数'
      }, {
        key: 'weekend_allnum',
        label: '周末申请次数'
      }, {
        key: 'weekend_orgnum',
        label: '周末申请机构数'
      }, {
        key: 'night_allnum',
        label: '夜间申请次数'
      }, {
        key: 'night_orgnum',
        label: '夜间申请机构数'
      }, {
        key: 'tot_mons',
        label: '有申请记录月份数'
      }, {
        key: 'avg_monnum',
        label: '平均每月申请次数'
      }, {
        key: 'max_monnum',
        label: '最大月申请次数'
      }, {
        key: 'min_monnum',
        label: '最小月申请次数'
      }];
    },
    blackSidePanels: function blackSidePanels() {
      var _this2 = this;
      var sides = [{
        key: 'idCard',
        title: '身份证维度',
        data: this.blackInfo && this.blackInfo.idCardSide || {}
      }, {
        key: 'mobile',
        title: '手机号维度',
        data: this.blackInfo && this.blackInfo.mobileSide || {}
      }];
      return sides.map(function (side) {
        return {
          key: side.key,
          title: side.title,
          rows: [{
            label: '风险等级',
            value: _this2.blackLevelLabel(side.data.level),
            tagClass: _this2.blackLevelTone(side.data.level)
          }, {
            label: '最新逾期/欺诈状态',
            value: _this2.blackConditionLabel(side.data.lastCondition),
            tagClass: _this2.blackConditionTone(side.data.lastCondition)
          }, {
            label: '近12月最严重状态',
            value: _this2.blackConditionLabel(side.data.seriousCondition),
            tagClass: _this2.blackConditionTone(side.data.seriousCondition)
          }, {
            label: '贷款类型',
            value: _this2.blackLoanTypeLabel(side.data.loanTypes),
            tagClass: ''
          }, {
            label: '近6月黑名单机构数',
            value: side.data.blackOrgNum != null && side.data.blackOrgNum !== '' ? side.data.blackOrgNum : '-',
            tagClass: Number(side.data.blackOrgNum) > 0 ? 'tone-warn' : ''
          }]
        };
      });
    }
  },
  created: function created() {
    // 从路由获取参数
    this.currentId = this.$route.query.id;
    this.currentType = this.$route.query.type;
    this.getInfo(this.currentId);
    // this.getInfo(20)
    // this.getInfo(16)
    // this.getInfo(10)
    // this.getInfo(14)
  },
  mounted: function mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    // 检测设备类型
    checkDevice: function checkDevice() {
      var clientWidth = document.documentElement.clientWidth;
      if (clientWidth <= 768) {
        this.deviceType = 'mobile';
      } else if (clientWidth <= 1024) {
        this.deviceType = 'tablet';
      } else {
        this.deviceType = 'desktop';
      }
    },
    getInfo: function getInfo(id) {
      var _this3 = this;
      // let id=20//pay_risk_behavior,探针
      // let id=16//unify,全景雷达
      // let id=10//score_pano,全景档案
      // let id= 14//court_detail_pro,法院信息
      (0, _request.default)({
        url: "/system/report/get_fengkong_info/",
        method: 'get',
        params: {
          shop_id: this.$user.data.shop,
          record_id: id
        }
      }).then(function (res) {
        //  if(id == 20 ){
        //      this.pay_risk_behavior_itf=res.data.results
        //  }

        //  if(id == 16){
        //      this.unify = res.data.results
        //  }

        //  if(id == 10){
        //       this.score_pano = res.data.results
        //  }

        //  if(id == 14){
        //      // 法院信息
        //     this.CourtDetailPro = res.data.results.CourtDetailPro

        //     // 调用方法，遍历CourtDetailProEntryList数组，根据dataType进行分类，然后赋值给CourtDetailProEntryListByType
        //     this.getCourtListByTypefn(this.CourtDetailPro.entryList)

        //  }

        // 1.探针C（未命中也展示页面）
        if (_this3.currentType == "pay_risk_behavior_money" || _this3.currentType == "pay_risk_behavior") {
          var results = res.data && res.data.results || {};
          var detail = results.result_detail && (0, _typeof2.default)(results.result_detail) === 'object' ? results.result_detail : results;
          _this3.pay_risk_behavior_itf = detail || {};
          _this3.probeSeqNo = results.seqNo || detail.seqNo || '';
          var rc = detail.result_code;
          var hasResultCode = rc != null && rc !== '';
          var isMissCode = results.code == '1' || results.code === 1 || results.hit === false || results.empty === true;
          // result_code 1~4 为命中态；未查得(code=1)或无 result_code 为空态
          _this3.probeHit = !isMissCode && hasResultCode && ['1', '2', '3', '4'].includes(String(rc));
          _this3.probeEmpty = isMissCode || !_this3.probeHit;
          _this3.probeEmptyMsg = results.error || results.msg || detail.error || (_this3.probeEmpty ? '查询未命中' : '');
          _this3.probeLoaded = true;
          if (_this3.probeEmpty) {
            _this3.$message({
              message: (_this3.probeEmptyMsg || '查询未命中') + '（本次查询已计费）',
              type: 'warning',
              duration: 6000
            });
          }
        }

        //  2.全景雷达
        if (_this3.currentType == "unify_money") {
          _this3.unify = res.data.results;
        }

        //  3.全景档案
        if (_this3.currentType == "score_pano_money") {
          _this3.score_pano = res.data.results;
        }
        if (_this3.currentType == "fengkong_default") {
          _this3.score_pano = res.data.results;
        }

        //  4.法院信息
        if (_this3.currentType == "court_detail_pro_money") {
          var _results = res.data && res.data.results || {};
          var cdp = _results.CourtDetailPro || {};
          _this3.CourtDetailPro = cdp;
          var entryList = Array.isArray(cdp.entryList) ? cdp.entryList : [];
          _this3.getCourtListByTypefn(entryList);
          _this3.courtLoaded = true;
          _this3.courtEmpty = entryList.length === 0 || cdp.hit === false || cdp.code === 'n' || _results.code == '1' || _results.code === 1;
          _this3.courtEmptyMsg = cdp.empty_msg || _results.error || _results.msg || '数据库未查得';
          if (_this3.courtEmpty) {
            _this3.$message({
              message: _this3.courtEmptyMsg + '（本次查询已计费）',
              type: 'warning',
              duration: 6000
            });
          }
        }

        // 5. 3C 租赁
        if (_this3.currentType == "apply_loan_c_money" || _this3.currentType == "apply_loan_c") {
          var _results2 = res.data && res.data.results || {};
          var nested = _results2.ApplyLoanC;
          if (!nested || (0, _typeof2.default)(nested) !== 'object') {
            // 兼容仅有扁平 alc_* 的旧数据
            nested = _this3.alcFlatToApplyLoanC(_results2.result_detail || _results2);
          }
          _this3.applyLoanC = nested || {};
          _this3.applyLoanSeqNo = _results2.seqNo || '';
          _this3.applyLoanLoaded = true;
          _this3.applyLoanEmpty = !_this3.applyLoanData.length || _results2.code == '1' || _results2.code === 1 || _results2.hit === false;
          _this3.applyLoanEmptyMsg = _results2.error || _results2.msg || (_this3.applyLoanEmpty ? '查询未命中' : '');
          if (_this3.applyLoanEmpty) {
            _this3.$message({
              message: (_this3.applyLoanEmptyMsg || '查询未命中') + '（本次查询已计费）',
              type: 'warning',
              duration: 6000
            });
          }
        }

        // 6. 金融黑名单
        if (_this3.currentType == "financial_blacklist_money" || _this3.currentType == "financial_blacklist") {
          var _results3 = res.data && res.data.results || {};
          var _detail = _results3.result_detail || _results3;
          _this3.blackInfo = {
            idCardSide: _detail && _detail.idCardSide || {},
            mobileSide: _detail && _detail.mobileSide || {}
          };
          _this3.blackSeqNo = _results3.seqNo || '';
          _this3.blackHit = _results3.is_black === true || _results3.hit === true;
          _this3.blackLoaded = true;
          _this3.blackEmpty = _results3.code == '1' || _results3.code === 1 || _results3.hit === false || !_this3.blackHit && !Object.keys(_this3.blackInfo.idCardSide).length && !Object.keys(_this3.blackInfo.mobileSide).length;
          _this3.blackEmptyMsg = _results3.error || _results3.msg || (_this3.blackEmpty ? '查询未命中' : '');
          if (_this3.blackEmpty) {
            _this3.$message({
              message: (_this3.blackEmptyMsg || '查询未命中') + '（本次查询已计费）',
              type: 'warning',
              duration: 6000
            });
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getTimeLabel: function getTimeLabel(timeKey) {
      var labels = {
        d3: '近3天',
        d7: '近7天',
        d14: '近14天',
        m1: '近1月',
        m3: '近3月',
        m6: '近6月',
        m12: '近12月'
      };
      return labels[timeKey] || timeKey;
    },
    blackLevelLabel: function blackLevelLabel(level) {
      var map = {
        '0': '未命中',
        '1': '轻微逾期',
        '2': '一般逾期',
        '3': '严重逾期',
        '4': '关联风险',
        '5': '疑似欺诈',
        '6': '欺诈'
      };
      if (level === undefined || level === null || level === '') return '-';
      return map[String(level)] || String(level);
    },
    blackLevelTone: function blackLevelTone(level) {
      var n = Number(level);
      if (level === undefined || level === null || level === '' || n === 0) return 'tone-ok';
      if (n <= 2) return 'tone-warn';
      return 'tone-danger';
    },
    blackConditionLabel: function blackConditionLabel(code) {
      var map = {
        'M1': 'M1 逾期1-30天',
        'M2': 'M2 逾期31-60天',
        'M3': 'M3 逾期61-90天',
        'M4': 'M4 逾期91-120天',
        'M5': 'M5 逾期121-150天',
        'M6': 'M6 逾期151-180天',
        'M6+': 'M6+ 逾期181天+',
        'Related risks': '关联风险',
        'Related risk': '关联风险',
        'suspected_fraud': '疑似欺诈',
        'fraud': '欺诈'
      };
      return code ? map[String(code)] || String(code) : '-';
    },
    blackConditionTone: function blackConditionTone(code) {
      if (!code) return '';
      var c = String(code);
      if (c === 'fraud' || c === 'suspected_fraud' || c.indexOf('Related') === 0 || c === 'M6+' || c === 'M6' || c === 'M5' || c === 'M4') {
        return 'tone-danger';
      }
      if (c === 'M1' || c === 'M2' || c === 'M3') return 'tone-warn';
      return '';
    },
    blackLoanTypeLabel: function blackLoanTypeLabel(code) {
      var map = {
        payday_loan: '发薪日贷款',
        micro_loan: '小额贷款',
        p2p: 'P2P',
        cf_edu: '消费金融-教育',
        cf_medical: '消费金融-医美',
        cf_rent: '消费金融-租房',
        cf_digital: '消费金融-数码',
        cf_car: '消费金融-买车',
        cf_deco: '消费金融-装修',
        cf_tour: '消费金融-旅游',
        cf_agri: '消费金融-农业',
        cf_others: '消费金融-其他',
        supply_chain: '供应链金融',
        leasing_company: '融资租赁',
        car_mortgage: '车辆抵押',
        house_mortgage: '房贷',
        credit_card: '信用卡',
        balance_transfer: '信用卡代偿',
        others: '其他',
        IOU: '借条'
      };
      return code ? map[String(code)] || String(code) : '-';
    },
    alcFlatToApplyLoanC: function alcFlatToApplyLoanC(flat) {
      var nested = {};
      if (!flat || (0, _typeof2.default)(flat) !== 'object') return nested;
      Object.keys(flat).forEach(function (key) {
        if (!key.startsWith('alc_')) return;
        var parts = key.slice(4).split('_');
        if (parts.length < 3) return;
        var period = parts[0];
        var side = parts[1];
        if (side !== 'id' && side !== 'cell') return;
        var metric = parts.slice(2).join('_');
        if (!nested[period]) nested[period] = {};
        if (!nested[period][side]) nested[period][side] = {};
        nested[period][side][metric] = flat[key];
      });
      return nested;
    },
    getCourtListByTypefn: function getCourtListByTypefn(data) {
      var result = {};
      if (!Array.isArray(data)) {
        this.CourtListByType = result;
        return;
      }
      data.forEach(function (item) {
        if (!item || !item.dataType) return;
        if (!result[item.dataType]) {
          result[item.dataType] = [];
        }
        result[item.dataType].push(item);
      });
      this.CourtListByType = result;
    },
    scrollToSection: function scrollToSection(sectionId) {
      var element = document.getElementById("section-".concat(sectionId));
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }
};